export const API_ROOT = {
  'development': 'https://server.compassbioinfo.com/',
  'production': 'https://server.compassbioinfo.com/'
}[process.env.NODE_ENV]



// WEBPACK FOOTER //
// ./src/api/config.js